import { useEffect, useLayoutEffect, useRef, useState } from 'react';
import {
  addMealSuggestionPhotos,
  removeMealSuggestionPhoto,
  resetMealSuggestionPhotos,
} from './mealSuggestionPhotos';

export function useMealSuggestionDraft(mealId) {
  const [constraintInput, setConstraintInput] = useState('');
  const [targetCaloriesInput, setTargetCaloriesInput] = useState('');
  const [includeExisting, setIncludeExisting] = useState(false);
  const [photoEntries, setPhotoEntries] = useState([]);
  const [photoFeedback, setPhotoFeedback] = useState([]);
  const entriesRef = useRef([]);
  const mealIdRef = useRef(String(mealId));

  const replacePhotoEntries = (nextEntries) => {
    entriesRef.current = nextEntries;
    setPhotoEntries(nextEntries);
  };

  const addPhotos = (files) => {
    const result = addMealSuggestionPhotos(entriesRef.current, files);
    replacePhotoEntries(result.entries);
    setPhotoFeedback(result.feedback);
    return result;
  };

  const removePhoto = (index) => {
    replacePhotoEntries(removeMealSuggestionPhoto(entriesRef.current, index));
    setPhotoFeedback([]);
  };

  const resetPhotos = () => {
    replacePhotoEntries(resetMealSuggestionPhotos(entriesRef.current));
    setPhotoFeedback([]);
  };

  useLayoutEffect(() => {
    const nextMealId = String(mealId);
    if (mealIdRef.current === nextMealId) return;
    resetMealSuggestionPhotos(entriesRef.current);
    entriesRef.current = [];
    setPhotoEntries([]);
    setPhotoFeedback([]);
    setConstraintInput('');
    setTargetCaloriesInput('');
    setIncludeExisting(false);
    mealIdRef.current = nextMealId;
  }, [mealId]);

  useEffect(() => () => {
    resetMealSuggestionPhotos(entriesRef.current);
    entriesRef.current = [];
  }, []);

  return {
    constraintInput,
    setConstraintInput,
    targetCaloriesInput,
    setTargetCaloriesInput,
    includeExisting,
    setIncludeExisting,
    photoEntries,
    photoFeedback,
    setPhotoFeedback,
    addPhotos,
    removePhoto,
    resetPhotos,
  };
}
